import { render, staticRenderFns } from "./ItemTabDetails.vue?vue&type=template&id=5cbd5dea&scoped=true"
import script from "./ItemTabDetails.vue?vue&type=script&lang=ts"
export * from "./ItemTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd5dea",
  null
  
)

export default component.exports